import { pushEventAndTrack, getSatelliteTrackingEvent } from '../../helpers/TaggingSerializer'
import getParams from '../../helpers/getParams'

const attachBVListener = (element, callback) => {
  if (window.document.querySelector(element)) {
    window.document.querySelector(element).addEventListener('click', () => {
      callback()
    })
  }
}

const updateTaggingByBVContentType = (digitalDataObject, directUpdate = null) => {
  const pageType = directUpdate !== null ? directUpdate : getParams('bvcontenttype')
  switch (pageType) {
    case 'REVIEW_SUBMISSION':
      digitalDataObject.page.pageInfo.pageName = `ar:cgc:reviewSubmission:`
      digitalDataObject.page.pageInfo.attributes.templateTitle = 'cgc_review_submissionForm'
      break

    case 'QUESTION_SUBMISSION':
      digitalDataObject.page.pageInfo.pageName = `ar:cgc:askQuestion:`
      digitalDataObject.page.pageInfo.attributes.templateTitle = 'cgc_askQuestion'
      break

    case 'ANSWER_SUBMISSION':
      digitalDataObject.page.pageInfo.pageName = `ar:cgc:answerQuestion:`
      digitalDataObject.page.pageInfo.attributes.templateTitle = 'cgc_answerQuestion'
      break

    case 'REVIEW_SUBMISSION_PREVIEW':
      digitalDataObject.page.pageInfo.pageName = `ar:cgc:reviewSubmission:preview:`
      digitalDataObject.page.pageInfo.attributes.templateTitle = 'review_submissionFormPreview'
      break

    case 'QUESTION_SUBMISSION_PREVIEW':
      digitalDataObject.page.pageInfo.pageName = `ar:cgc:askQuestion:preview:`
      digitalDataObject.page.pageInfo.attributes.templateTitle = 'cgc_askQuestionPreview'
      break

    default:
      break
  }
  return digitalDataObject
}

const setBVPageReviewListeners = () => {
  window.digitalData = updateTaggingByBVContentType(window.digitalData)

  attachBVListener('.BVPageReview #BVButtonSubmitID .BVButton', () => {
    const isOptedIn = window.document.querySelector('.BVPageReview #BVFieldUseremailalertsID').checked
    pushEventAndTrack({
      eventInfo: {
        eventName: 'cgc_clickSubmitReview',
        eventAction: 'CGC click Submit Review',
      },
      attributes: {
        reviewNotification: isOptedIn ? 'cgc_reviews_notification_optIn' : 'cgc_reviews_notification_optOut',
      },
    })
  })

  attachBVListener('.BVPageReview #BVButtonPreviewID .BVButton', () => {
    window.digitalData.page.pageInfo.pageName = `ar:cgc:reviewSubmission:preview:`
    window.digitalData.page.pageInfo.attributes.templateTitle = 'review_submissionFormPreview'
    getSatelliteTrackingEvent('cgc_clickPreviewReview')
  })

  attachBVListener('.BVPageReview #BVFieldRatingRatingStarsID', () => {
    pushEventAndTrack({
      eventInfo: {
        eventName: 'cgc_reviewsInteraction',
        eventAction: 'CGC Reviews Text Interaction',
      },
    })
  })
}

const setBVAskQuestionListeners = () => {
  attachBVListener('.BVPageQuestion #BVButtonPreviewID .BVButton', () => {
    let fieldAttribute = ''
    if (
      window.document.querySelector('.BVPageQuestion #BVFieldUseremailalertsID').checked &&
      !window.document.querySelector('.BVPageQuestion #BVFieldSendemailonanswerID').checked
    ) {
      fieldAttribute = 'cgc_ask_notification_optInBoth'
    } else if (
      window.document.querySelector('.BVPageQuestion #BVFieldUseremailalertsID').checked &&
      !window.document.querySelector('.BVPageQuestion #BVFieldSendemailonanswerID').checked
    ) {
      fieldAttribute = 'cgc_ask_notification_questionPosted'
    } else if (
      !window.document.querySelector('.BVPageQuestion #BVFieldUseremailalertsID').checked &&
      window.document.querySelector('.BVPageQuestion #BVFieldSendemailonanswerID').checked
    ) {
      fieldAttribute = 'cgc_ask_notification_questionAnswered'
    } else {
      fieldAttribute = 'cgc_ask_notification_optOutBoth'
    }
    pushEventAndTrack({
      eventInfo: {
        eventName: 'cgc_clickPreviewQuestion',
        eventAction: 'CGC Preview Question',
      },
      attributes: {
        reviewNotification: fieldAttribute,
      },
    })
  })

  attachBVListener('.BVPageQuestion #BVFieldQuestionsummaryID', () => {
    pushEventAndTrack({
      eventInfo: {
        eventName: 'cgc_AskQuestionInteraction',
        eventAction: 'CGC Ask a Question Field Interaction',
      },
      attributes: window.document.querySelector('.BVPageQuestion #BVFieldQuestionsummaryID').value,
    })
  })

  attachBVListener('.BVPageQuestion #BVButtonSubmitID .BVButton', () => {
    pushEventAndTrack({
      eventInfo: {
        eventName: 'cgc_clickSubmit',
        eventAction: 'CGC Submit Question',
      },
    })
  })
}

const setBVAnswerQuestionListeners = () => {
  attachBVListener('.BVPageAnswer #BVFieldAnswertextID', () => {
    pushEventAndTrack({
      eventInfo: {
        eventName: 'cgc_AnswerQuestionInteraction',
        eventAction: 'CGC Ask a Question Field Interaction',
      },
      attributes: window.document.querySelector('.BVPageAnswer #BVFieldAnswertextID').value,
    })
  })

  attachBVListener('.BVPageAnswer #BVButtonSubmitID .BVButton', () => {
    pushEventAndTrack({
      eventInfo: {
        eventName: 'cgc_clickSubmitAnswer',
        eventAction: 'CGC Submit Answer',
      },
    })
  })

  attachBVListener('.BVPageAnswer #BVButtonPreviewID .BVButton', () => {
    pushEventAndTrack({
      eventInfo: {
        eventName: 'cgc_clickPreviewAnswer',
        eventAction: 'CGC Preview Answer',
      },
      attributes: {
        reviewNotification: window.document.querySelector('#BVFieldUseremailalertsID').checked
          ? 'cgc_answer_notification_optIn'
          : 'cgc_answer_notification_optOut',
      },
    })
  })
}

const setBVListeners = () => {
  setBVPageReviewListeners()
  setBVAskQuestionListeners()
  setBVAnswerQuestionListeners()
}

export default setBVListeners
